import React from 'react';
import { Link } from 'react-router-dom';

export default function Button({ btnUrl, btnText, variant, onClick }) {
  // Si onClick est fourni, utiliser un bouton au lieu d'un Link
  if (onClick) {
    return (
      <button 
        onClick={onClick} 
        className={`cs_btn cs_style_1 ${variant}`}
        style={{ 
          background: 'none', 
          border: 'none', 
          width: '100%',
          cursor: 'pointer'
        }}
      >
        <span>{btnText}</span>
        <i>
          <img src="images/icons/arrow_white.svg" alt="Icon" />
          <img src="images/icons/arrow_white.svg" alt="Icon" />
        </i>
      </button>
    );
  }

  // Si c'est un lien externe (commence par http), utiliser un <a>
  if (btnUrl && (btnUrl.startsWith('http') || btnUrl.startsWith('#'))) {
    return (
      <a 
        href={btnUrl} 
        className={`cs_btn cs_style_1 ${variant}`}
        target={btnUrl.startsWith('http') ? '_blank' : undefined}
        rel={btnUrl.startsWith('http') ? 'noopener noreferrer' : undefined}
      >
        <span>{btnText}</span>
        <i>
          <img src="images/icons/arrow_white.svg" alt="Icon" />
          <img src="images/icons/arrow_white.svg" alt="Icon" />
        </i>
      </a>
    );
  }

  // Sinon, utiliser le Link de React Router
  return (
    <Link to={btnUrl} className={`cs_btn cs_style_1 ${variant}`}>
      <span>{btnText}</span>
      <i>
        <img src="images/icons/arrow_white.svg" alt="Icon" />
        <img src="images/icons/arrow_white.svg" alt="Icon" />
      </i>
    </Link>
  );
}
